module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAECAYAAACKqs+rAAAAAXNSR0IArs4c6QAAADRJREFUGBlj+P//vycQP4ZiTwYsgCw1UAOBFBg8xmIuA1AGZDEMEKWGCZtBVBEDOoMmQQEAubiE88FLvnwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/png/menu.png
// module id = 81
// module chunks = 0